bovoApp.controller('TicketController', ['$scope', 'Ticket', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Ticket, $location, $routeParams, $filter, $translate) {

    $scope.tickets = [];
    $scope.formData = {};
    $scope.ticket = {};
    $scope.filters = {};
    $scope.filterData = {};
    $scope.stats = {};
    $scope.pagination = {};
    $scope.loading = false;
    $scope.selectedTickets = [];
    $scope.selectedTicket = {};

    // Initialize
    $scope.init = function () {
      console.log('Initializing TicketController...');
      $scope.loadFormData();
      $scope.loadTickets();
      $scope.loadStats();
    };

    // Load form data (dropdowns, etc.)
    $scope.loadFormData = function () {
      Ticket.getFormData().success(function (data) {
        console.log('Form data loaded:', data);
        $scope.formData = data;
      }).error(function (error) {
        console.error('Form data loading error:', error);
        $scope.formData = {};
      });
    };

    // Load tickets with filters
    $scope.loadTickets = function (page = 1) {
      $scope.loading = true;
      var params = angular.copy($scope.filters);
      params.page = page;

      Ticket.getAll(params).success(function (data) {
        console.log('Tickets loaded:', data);
        $scope.tickets = data.tickets;
        $scope.pagination = data.pagination;
        $scope.loading = false;
      }).error(function (error) {
        console.error('Tickets loading error:', error);
        $scope.loading = false;
        Messenger().post({
          message: 'Ticketlar yüklenirken hata oluştu',
          type: "error"
        });
      });
    };

    // Load statistics
    $scope.loadStats = function () {
      Ticket.getStats().success(function (data) {
        $scope.stats = data;
        console.log('Stats loaded:', data);
      }).error(function (error) {
        console.error('Stats loading error:', error);
        $scope.stats = {
          total: 0,
          new: 0,
          in_progress: 0,
          resolved_today: 0,
          critical: 0,
          avg_resolution_hours: 0
        };
      });
    };

    // Open new ticket modal
    $scope.openNewTicket = function () {
      $scope.ticket = {
        priority: 'normal',
        region: 'İstanbul Avrupa',
        affected_shipment_count: 1,
        is_recurring: false,
        tracking_numbers: [''],
        reporter_name: $scope.authenticatedUser ? $scope.authenticatedUser.full_name : ''
      };
      setTimeout(function() {
        $('#ticketModal').modal('show');
      }, 100);
    };

    // Open ticket details
    $scope.openTicketDetails = function (ticketId) {
      $scope.loading = true;
      Ticket.get(ticketId).success(function (data) {
        $scope.selectedTicket = data.ticket;
        $scope.loading = false;
        setTimeout(function() {
          $('#ticketDetailsModal').modal('show');
        }, 100);
      }).error(function() {
        $scope.loading = false;
        Messenger().post({
          message: 'Ticket detayları yüklenirken hata oluştu',
          type: "error"
        });
      });
    };

    // Get problem types based on selected category
    $scope.getProblemTypes = function () {
      if ($scope.ticket.main_category && $scope.formData.categories) {
        return $scope.formData.categories[$scope.ticket.main_category] || [];
      }
      return [];
    };

    // Add tracking number field
    $scope.addTrackingNumber = function () {
      if (!$scope.ticket.tracking_numbers) {
        $scope.ticket.tracking_numbers = [];
      }
      $scope.ticket.tracking_numbers.push('');
    };

    // Remove tracking number field
    $scope.removeTrackingNumber = function (index) {
      $scope.ticket.tracking_numbers.splice(index, 1);
    };

    // Handle file selection
    $scope.onFileSelect = function (files) {
      $scope.ticket.attachments = files;
    };

    // Save new ticket
    $scope.saveTicket = function () {
      if (!$scope.validateTicket()) {
        return;
      }

      // Düzenleme modundaysa updateTicket'ı çağır
      if ($scope.ticket.isEditing) {
        $scope.updateTicket();
        return;
      }

      $scope.loading = true;

      // Create FormData for file upload
      var formData = new FormData();
      
      // Add all form fields
      Object.keys($scope.ticket).forEach(function (key) {
        if (key === 'attachments' && $scope.ticket[key]) {
          // Handle file uploads
          for (var i = 0; i < $scope.ticket[key].length; i++) {
            formData.append('attachments[]', $scope.ticket[key][i]);
          }
        } else if (key === 'tracking_numbers' && $scope.ticket[key]) {
          // Handle array fields
          $scope.ticket[key].forEach(function (item, index) {
            if (item.trim()) {
              formData.append('tracking_numbers[' + index + ']', item.trim());
            }
          });
        } else if ($scope.ticket[key] !== null && $scope.ticket[key] !== undefined) {
          formData.append(key, $scope.ticket[key]);
        }
      });

      Ticket.save(formData).success(function (data) {
        $scope.loading = false;
        $('#ticketModal').modal('hide');
        Messenger().post('Ticket başarıyla oluşturuldu');
        $scope.loadTickets();
        $scope.loadStats();
      }).error(function (data) {
        $scope.loading = false;
        Messenger().post({
          message: data.message || 'Kayıt sırasında hata oluştu',
          type: "error"
        });
      });
    };

    // Update ticket status
    $scope.updateTicketStatus = function (ticketId, status) {
        if (!$scope.hasPermission('ticket_update')) {
            Messenger().post({
                message: 'Bu işlem için yetkiniz bulunmamaktadır',
                type: "error"
            });
            return;
        }

        var updateData = { status: status };
        
        if (status === 'resolved') {
            var solution = prompt('Çözüm açıklaması girin:');
            if (!solution || solution.trim() === '') {
                Messenger().post({
                    message: 'Çözüm açıklaması zorunludur',
                    type: "error"
                });
                return;
            }
            updateData.solution_description = solution.trim();
        }

        $scope.loading = true;
        Ticket.update(ticketId, updateData).success(function (data) {
            $scope.loading = false;
            Messenger().post('Durum güncellendi');
            $scope.loadTickets();
            $scope.loadStats();
            
            // Modal açıksa güncelle
            if ($scope.selectedTicket && $scope.selectedTicket.id == ticketId) {
                $scope.selectedTicket = data.ticket;
            }
            
            // Modal kapatma kontrolü
            setTimeout(function() {
                $('#ticketDetailsModal').modal('hide');
            }, 1000);
        }).error(function (data) {
            $scope.loading = false;
            Messenger().post({
                message: data.message || 'Güncelleme sırasında hata oluştu',
                type: "error"
            });
        });
    };

    // Assign team
    $scope.assignTeam = function (ticketId, team) {
      if (!$scope.hasPermission('ticket_assign')) {
        Messenger().post({
          message: 'Ekip atama yetkiniz bulunmamaktadır',
          type: "error"
        });
        return;
      }

      $scope.loading = true;
      Ticket.update(ticketId, { assigned_team: team }).success(function (data) {
        $scope.loading = false;
        Messenger().post('Ekip atandı: ' + team);
        $scope.loadTickets();
        $scope.loadStats();
        
        // Modal açıksa selectedTicket'ı güncelle
        if ($scope.selectedTicket && $scope.selectedTicket.id == ticketId) {
          $scope.selectedTicket.assigned_team = team;
        }
      }).error(function (data) {
        $scope.loading = false;
        Messenger().post({
          message: data.message || 'Atama sırasında hata oluştu',
          type: "error"
        });
      });
    };

    // Delete ticket
    $scope.deleteTicket = function (ticketId) {
      if (!confirm('Bu ticketı silmek istediğinizden emin misiniz?')) {
        return;
      }

      Ticket.delete(ticketId).success(function (data) {
        Messenger().post('Ticket silindi');
        $scope.loadTickets();
        $scope.loadStats();
      }).error(function (data) {
        Messenger().post({
          message: data.message || 'Silme sırasında hata oluştu',
          type: "error"
        });
      });
    };

    // Apply filters
    $scope.applyFilters = function () {
      // Merge filterData.term into filters
      if ($scope.filterData.term) {
        $scope.filters.search = $scope.filterData.term;
      } else {
        delete $scope.filters.search;
      }
      
      $scope.loadTickets(1);
    };

    // Clear filters
    $scope.clearFilters = function () {
      $scope.filters = {};
      $scope.filterData = {};
      $scope.loadTickets(1);
    };

    // Pagination
    $scope.goToPage = function (page) {
      $scope.loadTickets(page);
    };

    // Filter by status (for stat cards)
    $scope.filterStatus = function (status) {
      $scope.filters.status = status;
      $scope.applyFilters();
    };

    // Filter by priority (for stat cards)
    $scope.filterPriority = function (priority) {
      $scope.filters.priority = priority;
      $scope.applyFilters();
    };

    // Pagination for directive
    $scope.getPage = function (page) {
      $scope.loadTickets(page);
    };

    // Sort functionality
    $scope.filterData = {};
    $scope.sort = function (field, direction) {
      $scope.filterData.field = field;
      $scope.filterData.sort = direction;
      $scope.filters.sort_field = field;
      $scope.filters.sort_direction = direction;
      $scope.applyFilters();
    };

    // Validate ticket form
    $scope.validateTicket = function () {
      if (!$scope.ticket.reporter_name || $scope.ticket.reporter_name.trim() === '') {
        Messenger().post({
          message: 'Bildiren personel adı zorunludur',
          type: "error"
        });
        return false;
      }

      if (!$scope.ticket.description || $scope.ticket.description.trim().length < 50) {
        Messenger().post({
          message: 'Problem açıklaması en az 50 karakter olmalıdır',
          type: "error"
        });
        return false;
      }

      if (!$scope.ticket.main_category) {
        Messenger().post({
          message: 'Ana kategori seçimi zorunludur',
          type: "error"
        });
        return false;
      }

      if (!$scope.ticket.problem_type) {
        Messenger().post({
          message: 'Problem tipi seçimi zorunludur',
          type: "error"
        });
        return false;
      }

      return true;
    };

    // Get priority badge class
    $scope.getPriorityClass = function (priority) {
      var classes = {
        'critical': 'label-danger',
        'high': 'label-warning',
        'normal': 'label-info',
        'low': 'label-success'
      };
      return classes[priority] || 'label-default';
    };

    // Get status badge class
    $scope.getStatusClass = function (status) {
      var classes = {
        'new': 'label-danger',
        'in_progress': 'label-warning',
        'waiting': 'label-info',
        'resolved': 'label-success',
        'cancelled': 'label-default'
      };
      return classes[status] || 'label-default';
    };

    // Get priority text
    $scope.getPriorityText = function (priority) {
      var texts = {
        'critical': 'Kritik',
        'high': 'Yüksek',
        'normal': 'Normal',
        'low': 'Düşük'
      };
      return texts[priority] || priority;
    };

    // Get status text
    $scope.getStatusText = function (status) {
      var texts = {
        'new': 'Yeni',
        'in_progress': 'İşlemde',
        'waiting': 'Beklemede',
        'resolved': 'Çözüldü',
        'cancelled': 'İptal'
      };
      return texts[status] || status;
    };

    // Format date
    $scope.formatDate = function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    };

    // Calculate resolution time
    $scope.getResolutionTime = function (hours) {
      if (!hours) return '-';
      
      if (hours < 1) {
        return Math.round(hours * 60) + ' dakika';
      } else if (hours < 24) {
        return Math.round(hours * 10) / 10 + ' saat';
      } else {
        return Math.round(hours / 24 * 10) / 10 + ' gün';
      }
    };

    // Get pages for pagination
    $scope.getPages = function (totalPages) {
      var pages = [];
      for (var i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    };

    // Permission check function
    $scope.hasPermission = function(permission) {
      // Basit yetki kontrolü - gerçek uygulamada JWT token'dan veya user role'den kontrol edilmelidir
      if (!$scope.authenticatedUser) return false;
      
      // Admin kullanıcılar tüm izinlere sahip
      if ($scope.authenticatedUser.role === 'admin' || $scope.authenticatedUser.role === 'superadmin') {
        return true;
      }
      
      // Temel izinler
      var permissions = {
        'ticket_create': true, // Herkes ticket oluşturabilir
        'ticket_update': $scope.authenticatedUser.role === 'manager' || $scope.authenticatedUser.role === 'admin',
        'ticket_assign': $scope.authenticatedUser.role === 'manager' || $scope.authenticatedUser.role === 'admin',
        'ticket_delete': $scope.authenticatedUser.role === 'admin'
      };
      
      return permissions[permission] || false;
    };

    // Show my tickets
    $scope.showMyTickets = function() {
      if (!$scope.authenticatedUser) return;
      
      $scope.filters.assigned_user = $scope.authenticatedUser.id;
      $scope.filterData.term = '';
      $scope.applyFilters();
    };

    // Show assigned to my team tickets
    $scope.showTeamTickets = function() {
      if (!$scope.authenticatedUser || !$scope.authenticatedUser.team) return;
      
      $scope.filters.assigned_team = $scope.authenticatedUser.team;
      $scope.filterData.term = '';
      $scope.applyFilters();
    };

    // Edit ticket
    $scope.editTicket = function(ticketId) {
      if (!$scope.hasPermission('ticket_update')) {
        Messenger().post({
          message: 'Ticket düzenleme yetkiniz bulunmamaktadır',
          type: "error"
        });
        return;
      }

      Ticket.get(ticketId).success(function (data) {
        $scope.ticket = angular.copy(data.ticket);
        $scope.ticket.isEditing = true;
        
        // Modal'ı aç
        setTimeout(function() {
          $('#ticketModal').modal('show');
        }, 100);
      }).error(function() {
        Messenger().post({
          message: 'Ticket bilgileri yüklenirken hata oluştu',
          type: "error"
        });
      });
    };

    // Update existing ticket
    $scope.updateTicket = function() {
      if (!$scope.validateTicket()) {
        return;
      }

      $scope.loading = true;
      var ticketData = angular.copy($scope.ticket);
      delete ticketData.isEditing;

      Ticket.update(ticketData.id, ticketData).success(function (data) {
        $scope.loading = false;
        $('#ticketModal').modal('hide');
        Messenger().post('Ticket güncellendi');
        $scope.loadTickets();
        $scope.loadStats();
      }).error(function (data) {
        $scope.loading = false;
        Messenger().post({
          message: data.message || 'Güncelleme sırasında hata oluştu',
          type: "error"
        });
      });
    };

    // Initialize on load
    $scope.init();

  }
]);